import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import React, { useEffect } from "react";
import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { useFormContext } from "react-hook-form";
import {
  useEquipment,
  useUser,
  useTypesUnits,
} from "@services/servicesGenericsTables";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import { UNIT_TYPES_CODES } from "@app/pages/samples/utils/constants";
import { toExponentialUppercase } from "@app/utils/functions";

const PreparationPuAmCM = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const filteredProcedures = useFilteredProcedures("PRE");
  const { typesUnitsis } = useTypesUnits();

  const { currentPreparation } = useAnalysis();
  const dry_calcination = form.watch("dry_calcination");
  const wet_dry = form.watch("wet_dry");
  const analysis_amount_sample = form.watch("analysis_amount_sample");
  const preparation_unit_type = form.watch("analysis_unit_types");

  useEffect(() => {
    let amountEquivalent = analysis_amount_sample;
    let preparationUnitType = preparation_unit_type;

    if (dry_calcination > 0) {
      if (
        preparationUnitType?.codigo === UNIT_TYPES_CODES.HUMEDO &&
        wet_dry > 0
      )
        amountEquivalent = (amountEquivalent * dry_calcination * wet_dry) / 1000;
      else if (preparationUnitType?.codigo === UNIT_TYPES_CODES.SECO)
        amountEquivalent = (amountEquivalent * dry_calcination) / 1000;
    }

    form.setValue(
      "amount_equivalent",
      amountEquivalent
        ? toExponentialUppercase(parseFloat(amountEquivalent), 3)
        : ""
    );
  }, [
    analysis_amount_sample,
    dry_calcination,
    wet_dry,
    preparation_unit_type,
    form,
  ]);

  return (
    <>
      {currentPreparation.index !== undefined && (
        <ResponsiveFormContainer columns={5}>
          <MAutocomplete
            key={JSON.stringify(form.getValues("analysis_analyst"))}
            name="analysis_analyst"
            options={userList}
            label="Seleccione un analista"
            getOptionLabel={(option) => option.username || ""}
            validation={{ required: "El analista es requerido" }}
            disabled={!currentPreparation.canEdit}
          />

          <MAutocomplete
            key={JSON.stringify(form.getValues("preparation_procedure"))}
            name="preparation_procedure"
            options={filteredProcedures}
            label="Procedimiento MLPMA"
            getOptionLabel={(option) => `${option.numop}` || ""}
            //validation={{ required: "El procedimiento es requerido" }}
            disabled={!currentPreparation.canEdit}
          />
          <MDatePicker
            name="start_date"
            pickerType="date"
            label="Fecha de inicio"
            validation={{
              required: "La fecha es requerida",
            }}
            disabled={!currentPreparation.canEdit}
          />

          <MAutocomplete
            key={JSON.stringify(form.getValues("analysis_unit_types"))}
            name="analysis_unit_types"
            options={typesUnitsis}
            label="Seleccione un tipo de unidad"
            getOptionLabel={(option) =>
              `${option.codigo} | ${option.descripcion}`
            }
            validation={{ required: "El tipo de unidad es requerido" }}
            disabled={!currentPreparation.canEdit}
          />

          <MTextField
            name="analysis_amount_sample"
            placeholder="Cantidad de muestra que se toma"
            label="Cantidad de muestra que se toma"
            type="number"
            validation={{ required: "La cantidad de muestra es requerida" }}
            fullWidth
            disabled={!currentPreparation.canEdit}
          />

          <MTextField
            key={JSON.stringify(form.getValues("amount_equivalent"))}
            name="amount_equivalent"
            placeholder="Cantidad de muestra"
            label="Cantidad de muestra"
            type="number"
            validation={{ required: "La cantidad de muestra es requerida" }}
            fullWidth
            disabled
          />

          <MAutocomplete
            key={JSON.stringify(form.getValues("analysis_equipment"))}
            name="analysis_equipment"
            options={equipmentList}
            label="Seleccione Equipos/Geometrías"
            getOptionLabel={(option) =>
              `${option.codigo} - ${option.descripcion}` || ""
            }
            validation={{ required: "El Equipos/Geometrías es requerido" }}
            multiple={true}
            disabled={!currentPreparation.canEdit}
          />

          <MDatePicker
            name="start_date_precipitation"
            pickerType="date"
            label="Fecha de electrodeposición"
            // validation={{
            //   required: "La fecha es requerida",
            // }}
            disabled={!currentPreparation.canEdit}
          />
          <MTextField
            key={JSON.stringify(form.getValues("valid_preparation"))}
            name="valid_preparation"
            placeholder="Preparación Válida"
            label="Preparación Válida"
            type="text"
            //validation={{ required: "La preparación válida es requerida" }}
            fullWidth
            disabled
          />
        </ResponsiveFormContainer>
      )}
    </>
  );
};

export default PreparationPuAmCM;
